import {emptyValue} from "./global";
export default function get_customer_type(customer_type) {
    if (customer_type === "BUSINESS") return "Gewerbekunde";
    else if (customer_type === "PRIVATE") return "Privatkunde";
    else return emptyValue;
}
